import { BodyText } from 'components/UI/Brand/text';
import translate from 'translate';
import { IPasswordValidation } from 'interfaces/IAuth';
import styled from 'styled-components';
import { Icon } from 'components';
import { colors } from 'style/colors';
import { ValidationRow } from './ValidationRow';

const Container = styled.div`
  margin: 16px 0 24px 0;
`;

const WarningRow = styled.div`
  display: flex;
  margin-bottom: 8px;
  gap: 8px;
`;

const WarningText = styled(BodyText)`
  font-weight: 500;
  color: ${colors.shared.warmGray5};
`;

interface IPasswordValidationProps {
  passwordValidation: IPasswordValidation;
}

const PasswordValidation = ({
  passwordValidation,
}: IPasswordValidationProps) => (
  <Container>
    <BodyText marginBottom="three">
      {translate('SetPasswordForm_ValidationLabel')}
    </BodyText>
    <WarningRow>
      <Icon
        iconType="circleWithExclamation"
        color="#d97706"
        width={24}
        height={24}
        style={{ minWidth: '24px' }}
      />
      <WarningText>
        {translate('SetPasswordForm_ValidationWarning')}
      </WarningText>
    </WarningRow>
    <div>
      <ValidationRow
        isValidationPassed={passwordValidation?.min15Chars}
        text={translate('SetPasswordForm_Validation_MinimumChars')}
      />
      <ValidationRow
        isValidationPassed={passwordValidation?.atLeastOneLowerCase}
        text={translate('SetPasswordForm_Validation_LowerCase')}
      />
      <ValidationRow
        isValidationPassed={passwordValidation?.atLeastOneCapital}
        text={translate('SetPasswordForm_Validation_CapitalLetter')}
      />
      <ValidationRow
        isValidationPassed={passwordValidation?.atLeastOneNumber}
        text={translate('SetPasswordForm_Validation_AtleastOneNumber')}
      />
      <ValidationRow
        isValidationPassed={passwordValidation?.atLeastOneSymbol}
        text={translate('SetPasswordForm_Validation_AtleastOneSymbol')}
      />
    </div>
  </Container>
);

export default PasswordValidation;
